export default __webpack_public_path__ + "static/media/MapIconJobDetail.d928e8b9.svg";